export default {
    'create-financial-file': 'Crear archivo financiero',
    'create-backup': 'Crear copia de seguridad',
    'edit-financial-file': 'Editar archivo financiero',
    'backups-management': "Gestión de Copias de Seguridad",
    'delete-old-backups': "Eliminar Copias de Seguridad Antiguas",
    'old-backups-delete-alert': "Se eliminarán todas las copias de seguridad creadas hace más de 7 días",
    'close': "Cerrar",
    save: 'Guardar',
    cancel: 'Cancelar',
    "configure-financial-file": "Configurar archivo financiero",
    "financial-file-created-successfully": "El archivo financiero ha sido creado con éxito !",
    "configure-your-financial-file": "¿Desea configurar su archivo financiero ahora?",
    "create-default-warehouse": "Crear almacén por defecto",
    "default-warehouse": "Almacén por defecto",
    "create-accounting-tree": "Crear árbol contable",
    "do-you-want-to-create-a-default-accounting-tree": "¿Desea crear un árbol contable por defecto? (Se recomienda)",
    "configure": "Configurar",
    "created-and-configured-successfully": "El archivo financiero ha sido creado y configurado con éxito !",
    "go-to-settings": "¿Desea personalizar algunos ajustes para su archivo financiero? Haga clic aquí para ir a la página de configuración",
    confirm: 'Seguimiento',
    'browse-content': 'Explorar contenido',

    'do-you-want-to-change-the-current-financial-file': '¿Está seguro de que desea cambiar el archivo financiero actual?',

    'rotated-to-$': 'Trasladado a {financialFile}',
    rotated: 'Cerrado',
    locked: 'Cerrado',
    unlocked: 'No cerrado',

    'the-users-of-the-file-$-and-their-permissions': '{financialFile} Usuarios de Archivos y sus permisos',

    permissions: {
        title: 'Permisos',
        'no-permissions': 'No permisos',
        viewer: 'Permiso de sólo lectura',
        accountant: 'Contador',
        'warehouse-keeper': 'Encargada de almacén',
        'warehouse-manager': 'Jefe de almacén'
    },

    'the-logo-is-uploaded-successfully': 'El logotipo se ha adjuntado con éxito.'
}